import React, { useState } from "react";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
// import Logo from "../../images/logo.png";
// import LogoDark from "../../images/logo-dark.png";
import { Form, FormGroup, Spinner, Alert } from "reactstrap";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
// import AuthFooter from "./AuthFooter";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL, getPublicUrl } from "../../utils/Utils";
import { userHasAdminAccess } from "../../utils/adminAccess";

const Login = () => {
  const [loading, setLoading] = useState(false);
  /** Tant que false, on n’affiche pas le formulaire (évite flash + boucle token périmé). */
  const [sessionReady, setSessionReady] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");
  // eslint-disable-next-line no-unused-vars
  const history = useHistory(); // Kept for potential future use

  // Si un accessToken est présent : vérifier /user/me AVANT de rediriger (sinon token invalide → / → 401 → retour brutal).
  React.useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem("accessToken");
    if (!token || !String(token).trim()) {
      setSessionReady(true);
      return () => {
        cancelled = true;
      };
    }

    axios
      .get(`${API_BASE_URL}/api/v1/user/me`, {
        headers: { Authorization: `Bearer ${token}` },
        validateStatus: (s) => s === 200 || s === 401,
      })
      .then((res) => {
        if (cancelled) return;
        const user = res.data && res.data.data;
        if (res.status === 401 || !user) {
          localStorage.removeItem("accessToken");
          setSessionReady(true);
          return;
        }
        if (userHasAdminAccess(user)) {
          window.location.href = getPublicUrl("");
          return;
        }
        localStorage.removeItem("accessToken");
        setError("This account does not have administrator access.");
        setSessionReady(true);
      })
      .catch(() => {
        if (cancelled) return;
        localStorage.removeItem("accessToken");
        setSessionReady(true);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const onFormSubmit = (formData) => {
    setLoading(true);
    axios
      .post(`${API_BASE_URL}/api/v1/user/login`, formData)
      .then(function (response) {
        if (response.data.success) {
          console.log("✅ Login successful:", response.data);
          
          // Sauvegarder le token
          const token = response.data.token;
          console.log("💾 Saving token to localStorage:", token ? "Token présent" : "Token manquant");
          localStorage.setItem("accessToken", token);
          
          // Vérifier que le token est bien sauvegardé
          const savedToken = localStorage.getItem("accessToken");
          console.log("🔍 Token sauvegardé vérifié:", savedToken ? "OUI" : "NON");
          
          window.sessionStorage.setItem("email", response.data.data.email);
          var fullName =
            response.data.data.first_name + " " + response.data.data.last_name + " " + (response.data.data.middle_name || "");
          window.sessionStorage.setItem("userName", fullName);
          
          // Redirection avec React Router - utiliser window.location pour éviter les conflits
          console.log("🔄 Redirection vers le dashboard...");
          // Utiliser window.location au lieu de history.push pour éviter les conflits avec AdminRoute
          window.location.href = getPublicUrl("");
        } else {
          setError(response.data.message);
          setLoading(false);
        }
      })
      .catch(function (error) {
        const status = error.response && error.response.status;
        const apiErr =
          (error.response && error.response.data && error.response.data.error) || null;
        if (status === 401) {
          setError(apiErr || "Invalid email or password");
        } else if (status === 429) {
          setError(apiErr || "Too many login attempts. Please wait 15 minutes or try from another network.");
        } else {
          setError(apiErr || error.message || "Connection failed. Make sure the API server is running.");
        }
        setLoading(false);
      });
  };

  const { errors, register, handleSubmit } = useForm();

  return (
    <React.Fragment>
      <Head title="Login" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-center">
            {/* <Link to={process.env.PUBLIC_URL + "/"} className="logo-link"> */}
            <h2>Inoqare Admin</h2>
            {/* <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" /> */}
            {/* <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" /> */}
            {/* </Link> */}
          </div>

          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            <BlockHead>
              <BlockContent>
                <BlockTitle tag="h4">Sign-In</BlockTitle>
                <BlockDes>
                  <p>Access Admin Portal using your email and password.</p>
                </BlockDes>
              </BlockContent>
            </BlockHead>
            {errorVal && (
              <div className="mb-3">
                <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" /> {errorVal}
                </Alert>
              </div>
            )}
            {!sessionReady ? (
              <div className="text-center py-5">
                <Spinner color="primary" />
                <p className="text-soft small mt-3 mb-0">Checking session…</p>
              </div>
            ) : null}
            {sessionReady ? (
            <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Email or Username
                  </label>
                </div>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    id="default-01"
                    name="email"
                    autoComplete="username"
                    ref={register({ required: "This field is required" })}
                    placeholder="Enter your email address or username"
                    className="form-control-lg form-control"
                  />
                  {errors.email && <span className="invalid">{errors.email.message}</span>}
                </div>
              </FormGroup>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="password">
                    Password
                  </label>
                  <Link className="link link-primary link-sm" to={getPublicUrl("auth-reset")}>
                    {/* Forgot Code? */}
                  </Link>
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="password"
                    name="password"
                    autoComplete="current-password"
                    ref={register({ required: "This field is required" })}
                    placeholder="Enter your password"
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                  />
                  {errors.password && <span className="invalid">{errors.password.message}</span>}
                </div>
              </FormGroup>
              <FormGroup>
                <Button size="lg" className="btn-block" type="submit" color="primary">
                  {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
                </Button>
              </FormGroup>
            </Form>
            ) : null}
            <div className="form-note-s2 text-center pt-4">
              {" "}
              {/* New on our platform? <Link to={`${process.env.PUBLIC_URL}/auth-register`}>Create an account</Link> */}
            </div>
            <div className="text-center pt-4 pb-3">
              {/* <h6 className="overline-title overline-title-sap">
                <span>OR</span>
              </h6> */}
            </div>
            <ul className="nav justify-center gx-4">
              <li className="nav-item">
                {/* <a
                  className="nav-link"
                  href="#socials"
                  onClick={(ev) => {
                    ev.preventDefault();
                  }}
                >
                  Facebook
                </a> */}
              </li>
              <li className="nav-item">
                {/* <a
                  className="nav-link"
                  href="#socials"
                  onClick={(ev) => {
                    ev.preventDefault();
                  }}
                >
                  Google
                </a> */}
              </li>
            </ul>
          </PreviewCard>
        </Block>
        {/* <AuthFooter /> */}
      </PageContainer>
    </React.Fragment>
  );
};
export default Login;
